import React, { Component } from "react";
import { Button, Form, Segment } from "semantic-ui-react";
import { Translate } from "react-localize-redux";

export default class SearchBox extends Component {


    constructor(props) {
        super(props);
        this.state = {
            code: ""
        };
    }


    render() {


        return (
            <Translate>
                {({translate})=>(
                    <Segment>
                        <Form style={{minWidth: '50vw'}} loading={this.props.loading} onSubmit={(e) => {
                            e.preventDefault();
                            this.props.callback(this.state.code);
                            this.setState({ code: "" });
                        }}>
                            <Form.Input minLength="4" autoFocus label={translate('inventory.button.codeOrEAN')} name='code' type='text'

                                        onChange={(e) => {
                                            this.setState({ code: e.target.value });
                                        }}/>
                            <Button fluid type='submit' primary>{translate('general.search')}</Button>
                        </Form>
                    </Segment>
                )}
            </Translate>
        );
    }


}




// WEBPACK FOOTER //
// ./src/scenes/Inventory/components/SearchBox/index.js